import * as React from "react";
import styled from "styled-components";

import FormField from "@ingka/form-field";
import Select, { Option as SelectOption } from "@ingka/select";
import Button from "@ingka/button";
import Skeleton from "@ingka/skeleton";

import SelectMarkets from "../SelectMarkets/SelectMarkets";
import { SrOnly } from "../styles";

const StyledWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	min-height: 18rem;
`;

export const StyledButton = styled(Button)`
	width: fit-content;
	margin-left: 2em;
`;

const StyledDiv = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
`;

const SkeletonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.2rem;
	margin: 1rem 0 1rem 0;
`;

interface ApplicationData {
	id: string;
	name: string;
}

interface RequestApplicationLayout {
	selectedApplication?: ApplicationData;
	setSelectedApplication: (application?: ApplicationData) => void;
	onRequestAccess: () => void;
	accessReqLoading: boolean;
	data?: ApplicationData[];
	setSelectedMarkets: (val: string[]) => void;
	selectedMarkets: string[];
	marketsData: any[];
	applicationsLoading: boolean;
	marketsDataLoading: boolean;
}

const Layout: React.FC<RequestApplicationLayout> = ({
	selectedApplication,
	setSelectedMarkets,
	setSelectedApplication,
	data,
	accessReqLoading,
	onRequestAccess,
	selectedMarkets,
	marketsData,
	marketsDataLoading,
	applicationsLoading,
}) => {
	return (
		<>
			<SrOnly id="loading-message" role="status" aria-live="polite" aria-atomic="true">
				{accessReqLoading && "Loading"}
			</SrOnly>
			<StyledWrapper>
				<div>
					{applicationsLoading ? (
						<SkeletonWrapper>
							<SkeletonWrapper>
								<Skeleton />
							</SkeletonWrapper>
							<Skeleton width="8rem" />
							<Skeleton height="2.8rem" />
						</SkeletonWrapper>
					) : (
						<>
							<p>Please select application you want to get access in Flagga.</p>
							<FormField>
								<Select
									data-autofocus
									required
									id="request-application-access"
									label="Select Application*"
									value={selectedApplication?.id}
									disabled={accessReqLoading}
									onChange={(e) => {
										setSelectedMarkets([]);
										if (e.target.value === "Choose an option") {
											setSelectedApplication(undefined);
										} else {
											const app = data?.find((application) => application.id === (e.target.value as string));
											if (app?.id) setSelectedApplication({ id: app?.id, name: app?.name });
											else setSelectedApplication(undefined);
										}
									}}
								>
									{data?.map((application) => (
										<SelectOption
											id={application.id}
											key={application.id}
											value={application.id}
											name={application.name}
										/>
									))}
								</Select>
							</FormField>
						</>
					)}
					{selectedApplication && (
						<SelectMarkets
							id="new-app-access"
							label="Select Market (optional)"
							marketsData={marketsData}
							selected={selectedMarkets}
							loading={marketsDataLoading || applicationsLoading}
							onChange={setSelectedMarkets}
							checkKeys={true}
						/>
					)}
				</div>

				<StyledDiv>
					<StyledButton
						text="Request Access"
						type="emphasised"
						disabled={!selectedApplication}
						onClick={onRequestAccess}
						loading={accessReqLoading}
						id="request-access-button"
					/>
				</StyledDiv>
			</StyledWrapper>
		</>
	);
};

export default Layout;
